import React from "react";
import { Button, Card, CardContent, Typography } from "@material-ui/core";
import _ from "lodash";

/**
 * Read-only language indicator for Version Settings (shown under playable size).
 * Language is changed on the Localization tab — this only displays + navigates.
 *
 * @param props.classes
 * @param props.selectedLanguage
 * @param props.supportedLanguages
 * @param props.onNavigateToLocalization
 */
export default function localizationOverrideLanguageCard(props) {
  const selectedLanguage = props.selectedLanguage || "en";
  const languageCaption = _.get(props.supportedLanguages, selectedLanguage, selectedLanguage);

  return (
    <Card className={props.classes.card}>
      <CardContent>
        <Typography variant={"h6"}>Language</Typography>
        <div
          style={{
            marginTop: "0.5rem"
          }}
        >
          <Typography variant={"subtitle1"}>{languageCaption}</Typography>
        </div>
        {selectedLanguage !== "en" && (
          <Typography variant="caption" style={{ display: "block", marginTop: "0.25rem", opacity: 0.8 }}>
            Editing overrides — English base unchanged.
          </Typography>
        )}
        <Button
          id={"navigateToLocalizationLanguage"}
          color="secondary"
          variant="contained"
          style={{
            margin: "1rem 5rem 0 0"
          }}
          onClick={() => {
            if (_.isFunction(props.onNavigateToLocalization)) {
              props.onNavigateToLocalization();
            }
          }}
        >
          Change in Localization
        </Button>
      </CardContent>
    </Card>
  );
}
